module.exports = __webpack_public_path__ + "static/media/wizualizacja-7.7c493316.png";